import React, { useContext, useEffect, useState } from 'react';
import { RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import styles from './styles.css';
import { displayAddress, shouldDisplayCancelorCloseBtn } from './utils';
import {
  getOriginalResidentialAddress,
  getCorrectedResidentialAddress,
  getOriginalMailingAddress,
  getCorrectedMailingAddress
} from '../../flows/shared/utils';
import { modalCloseHandler, modalCloseNextModalHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const DisplayAddressModalButtons = ({
  resAddressFilled,
  mailingAddressFilled,
  mailingAddressDifferent,
  consumerName,
  accountType
}) => {
  const { next, closeNextModal } = useContext(FlowContext);
  return (
    <div className="address-modal-btn-container" slot="action-zone">
      {shouldDisplayCancelorCloseBtn(consumerName, accountType) && (
        <MFBeaconButton
          type="button"
          variant="tertiary"
          id="addressValidationModalCancel"
          data-name={generateGeneralTestID(
            'AddressValidationModal',
            'CancelButton'
          )}
          noButtonMargin
          onClick={() => {
            modalCloseNextModalHandler(closeNextModal);
          }}
          label="Cancel"
        />
      )}
      <MFBeaconButton
        type="button"
        variant="primary"
        id="addressValidationModalContinue"
        data-name={generateGeneralTestID(
          'AddressValidationModal',
          'ContinueButton'
        )}
        noButtonMargin
        onClick={
          resAddressFilled && (!mailingAddressDifferent || mailingAddressFilled)
            ? () => {
                modalCloseHandler();
                next()();
              }
            : next('skipCloseNextModal')
        }
        label="Continue"
      />
      <style jsx>{styles}</style>
    </div>
  );
};

// @Abhinav - fix complexity
/* eslint-disable complexity */
const AddressValidationModal = () => {
  const { appState, closeNextModal, formProps } = useContext(FlowContext);
  const {
    residentialAddressValidation,
    mailingAddressValidation = {},
    mailingAddressDifferent,
    consumerName,
    accountType
  } = appState.store;

  // runs document query and appends blocked data class to address labels
  // US447565 - [AE] Mask PII data in Quantum
  /* eslint-disable no-return-assign */
  /* eslint-disable no-param-reassign */
  useEffect(() => {
    document
      .querySelectorAll('label')
      .forEach(label => (label.className += ' blocked_data'));
  }, []);
  /* eslint-enable no-return-assign */
  /* eslint-enable no-param-reassign */

  const originalResidentialAddress = getOriginalResidentialAddress(
    residentialAddressValidation
  );
  const correctedResidentialAddress = getCorrectedResidentialAddress(
    residentialAddressValidation
  );
  const originalMailingAddress = getOriginalMailingAddress(
    mailingAddressValidation
  );
  const correctedMailingAddress = getCorrectedMailingAddress(
    mailingAddressValidation
  );

  const [resAddressFilled, setResAddressFilled] = useState(false);
  const [mailingAddressFilled, setMailingAddressFilled] = useState(false);

  const residentialOptions = [
    {
      title: `Original Address: ${displayAddress(originalResidentialAddress)}`,
      value: 'useOriginalResidentialAddress'
    }
  ];
  if (correctedResidentialAddress) {
    residentialOptions.push({
      title: `Suggested Address: ${displayAddress(
        correctedResidentialAddress
      )}`,
      value: 'useRecommendedResidentialAddress'
    });
  }

  let mailingOptions = [];

  if (mailingAddressDifferent) {
    mailingOptions = [
      {
        title: `Original Address: ${displayAddress(originalMailingAddress)}`,
        value: 'useOriginalMailingAddress'
      }
    ];
    if (correctedMailingAddress) {
      mailingOptions.push({
        title: `Suggested Address: ${displayAddress(correctedMailingAddress)}`,
        value: 'useRecommendedMailingAddress'
      });
    }
  }

  return (
    <div className="address-modal-wrapper">
      <MFBeaconModal
        open
        removeCloseButton
        className="override-beacon-modal-block-size">
        {shouldDisplayCancelorCloseBtn(consumerName, accountType) && (
          <span className="modal-close-icon">
            <MFBeaconIconButton
              id="addressValidationModalCloseIcon"
              data-name={generateGeneralTestID(
                'AddressValidationModal',
                'CloseIconButton'
              )}
              variant="tertiary"
              onClick={() => modalCloseNextModalHandler(closeNextModal)}
              label="close-button">
              <img slot="icon" src={closeBtn} alt="close icon" />
            </MFBeaconIconButton>
          </span>
        )}
        <div className="beacon-modal__title">
          The U.S. Postal Service suggests a modified residential address
        </div>
        <RadioGroupField
          title="Residential Address"
          name="useResidentialAddress"
          options={residentialOptions}
          {...formProps.useResidentialAddress}
          onChange={() => setResAddressFilled(true)}
        />

        {mailingAddressDifferent && (
          <RadioGroupField
            title="Mailing Address"
            name="useMailingAddress"
            options={mailingOptions}
            {...formProps.useMailingAddress}
            onChange={() => setMailingAddressFilled(true)}
          />
        )}

        <DisplayAddressModalButtons
          resAddressFilled={resAddressFilled}
          mailingAddressFilled={mailingAddressFilled}
          mailingAddressDifferent={mailingAddressDifferent}
          consumerName={consumerName}
          accountType={accountType}
        />
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </div>
  );
};

export default AddressValidationModal;
